import * as React from "react";
import { IWPImage, IWPLink } from "@/src/types";
import { MainSection } from "@/styles/global";
import S from "./StandardBlock.styled";
import Tag from "@/components/global-components/Tag";
import { getBgColor, toGatsbyImage } from "@/src/helpers";
import Button from "@/components/global-components/Button";
import HandsIcon from "@/assets/hands.svg";
import { renderIcon } from "@/src/helpers";
export interface Props {
  backgroundColor: string;
  blocks: {
    tag: string;
    hasTag: boolean;
    title: string;
    titleType: string;
    videoUrl: string;
    ingress: string;
    wysiwygContent: string;
    link: IWPLink;
    linkIcon: string;
    button: IWPLink;
    image: IWPImage;
    hasInfobox: boolean;
    infoBoxContent: {
      boxBackgroundColor: string;
      boxTitle: string;
      boxContent: string;
      boxLink: IWPLink;
      boxLinkIcon: string;
      boxButton: IWPLink;
    };
  }[];
}

const StandardBlock: React.FC<Props> = ({ blocks, backgroundColor }) => {
  const renderTitle = (title: string, titleType: string) => {
    if (titleType === "h2") {
      return <S.H2>{title}</S.H2>;
    } else if (titleType === "h3") {
      return <S.H3>{title}</S.H3>;
    } else if (titleType === "h4") {
      return <S.H4>{title}</S.H4>;
    } else if (titleType === "h5") {
      return <S.H5>{title}</S.H5>;
    } else if (titleType === "h6") {
      return <S.H6>{title}</S.H6>;
    } else {
      return <S.H2>{title}</S.H2>;
    }
  };

  const renderBlocks = blocks?.map(
    (
      {
        tag,
        hasTag,
        linkIcon,
        title,
        titleType,
        videoUrl,
        ingress,
        image,
        button,
        link,
        wysiwygContent,
        hasInfobox,
        infoBoxContent: {
          boxBackgroundColor,
          boxButton,
          boxContent,
          boxLink,
          boxLinkIcon,
          boxTitle,
        },
      },
      index
    ) => {
      const imageData = toGatsbyImage(image);

      return (
        <S.Wrapper key={index}>
          {videoUrl && (
            <S.VideoWrapper>
              <S.VimeoHero dangerouslySetInnerHTML={{ __html: videoUrl }} />
              <S.IconWrapper>
                <HandsIcon />
              </S.IconWrapper>
            </S.VideoWrapper>
          )}
          {tag && hasTag && <Tag tag={tag} />}
          {title && renderTitle(title, titleType)}
          {ingress && <S.Ingress>{ingress}</S.Ingress>}
          {wysiwygContent && (
            <S.TextContent
              dangerouslySetInnerHTML={{ __html: wysiwygContent }}
            />
          )}
          {link && (
            <S.Link to={link.url} target={link.target}>
              {link.title}
              {renderIcon(linkIcon)}
            </S.Link>
          )}
          {button && (
            <S.ButtonWrapper>
              <Button link={button} type="primary" />
            </S.ButtonWrapper>
          )}
          {imageData && <S.Image image={imageData} alt={image.altText || ""} />}
          {hasInfobox && (
            <S.InfoBox $bgColor={getBgColor("light", boxBackgroundColor)}>
              {boxTitle && <S.InfoBoxTitle>{boxTitle}</S.InfoBoxTitle>}
              {boxContent && <S.Text>{boxContent}</S.Text>}
              {boxLink && (
                <S.InfoBoxLink href={boxLink.url}>
                  {renderIcon(boxLinkIcon)}
                  {boxLink.title}
                </S.InfoBoxLink>
              )}
              {boxButton && <Button link={boxButton} type="primary" />}
            </S.InfoBox>
          )}
        </S.Wrapper>
      );
    }
  );

  return (
    <MainSection $bgColor={backgroundColor}>
      <S.Inner>{renderBlocks}</S.Inner>
    </MainSection>
  );
};

export default StandardBlock;
